import { createReducer } from '@reduxjs/toolkit';
import { apiRequestSuccess } from 'services/api/api.actions';
import { dynamicNavbarContentEndpointResourceId } from './cmsContent.config';
import { NavbarContent } from './cmsContent.types';

const initialState = {
  navbar: {} as NavbarContent,
};

const cmsContentReducer = createReducer(initialState, (builder) =>
  builder.addCase(apiRequestSuccess, (state, action) => {
    if (action.payload.resourceId === dynamicNavbarContentEndpointResourceId) {
      const responsePayload = action.payload.response.data;

      if (responsePayload && typeof responsePayload === 'object') {
        state.navbar = responsePayload as NavbarContent;
      }
    }
  }),
);

export default cmsContentReducer;
